import { render, staticRenderFns } from "./lastContent.vue?vue&type=template&id=7aafff80&"
import script from "./lastContent.vue?vue&type=script&lang=js&"
export * from "./lastContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports